"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callRestApi = callRestApi;
exports.createRestApiRejectHandler = createRestApiRejectHandler;
exports.setupRestApi = setupRestApi;
var _loggingAndErrors = require("@avantia/logging-and-errors");
var _axios = _interopRequireDefault(require("axios"));
var _logging = require("./logging");
var _microTimer = require("./microTimer");
var _transformJsonObject = require("./transformJsonObject");
var _utilities = require("./utilities");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const defaultRequestTimeout = 30000;
const voidLogFunction = () => false;
let requestFunc = (0, _utilities.ensureOfType)(_axios.default, 'function', 'axios');
let logFailureFn = voidLogFunction;
let logSuccessFn = voidLogFunction;
let requestTimeout = defaultRequestTimeout;
function setupRestApi({
  instance,
  logFailure,
  logSuccess,
  timeout
}) {
  requestFunc = (0, _utilities.ensureOfType)(instance || _axios.default, 'function', 'instance OR axios');
  logFailureFn = logFailure || voidLogFunction;
  logSuccessFn = logSuccess || voidLogFunction;
  requestTimeout = timeout || defaultRequestTimeout;
}
function callRestApi(request) {
  const {
    responseKeyTransform,
    testInstance,
    timeout
  } = request;
  if (!timeout || timeout <= 0) {
    request.timeout = requestTimeout;
  }
  const timer = new _microTimer.MicroTimer();
  return new Promise((resolve, reject) => {
    (testInstance || requestFunc)(request).then(resp => {
      const response = resp;
      const {
        status: statusCode
      } = response;
      let {
        data
      } = response;
      if (statusCode >= 200 && statusCode < 300) {
        logSuccessFn(_objectSpread(_objectSpread({}, request), {}, {
          statusCode,
          timer,
          responseData: data
        }));
        if (responseKeyTransform) {
          data = (0, _transformJsonObject.transformJsonObject)(data, responseKeyTransform);
        }
        resolve({
          data,
          response
        });
      } else {
        const error = new _logging.HpWebRequestError({
          request,
          message: `The statusCode is ${statusCode}`,
          timer
        });
        error.statusCode = statusCode;
        error.responseData = data;
        if (logFailureFn(error)) {
          error.isLogged = true;
        }
        reject(error);
      }
    }).catch(createRestApiRejectHandler(request, timer, reject));
  });
}
function createRestApiRejectHandler(request, timer, reject) {
  return reason => {
    let error;
    try {
      error = createError(reason, request, timer);
    } catch (ex) {
      const exception = ex;
      const message = exception ? exception.message : null;
      (0, _logging.logError)(`Failed to create an error object: ${message || ex}${message ? `\n${ex}` : ''}`);
      error = new _loggingAndErrors.HpError(reason);
    }
    reject(error);
  };
}
function createError(reason, request, timer) {
  let responseData;
  let statusCode;
  let message;
  const axErr = reason;
  if (axErr && axErr.isAxiosError) {
    const {
      response,
      message: msg
    } = axErr;
    if (response) {
      const {
        status,
        data
      } = response;
      if (status) {
        statusCode = status;
        message = `Request failed with status code ${statusCode}`;
      }
      if (data) {
        responseData = data;
      }
    }
    if (!message) {
      message = msg;
    }
  } else {
    message = reason;
  }
  const error = new _logging.HpWebRequestError({
    request,
    message,
    timer
  });
  if (statusCode) {
    error.statusCode = statusCode;
  }
  if (responseData !== undefined) {
    error.responseData = responseData;
  }
  if (logFailureFn(error)) {
    error.isLogged = true;
  }
  return error;
}